import axios from 'axios';

export const getUsers = async(token, url=process.env.REACT_APP_API_USERS) => {
    const config = token ? { headers: {Authorization: 'Bearer ' + token} } : { headers: {Authorization: ''} }
    return axios.get(url, config);
}

export const getUser = async(token, id, url=process.env.REACT_APP_API_USERS) => {
    const config = token ? { headers: {Authorization: 'Bearer ' + token} } : { headers: {Authorization: ''} }
    return axios.get(`${url}/${id}`, config);
}

export const getMyUser = (token, url=`${process.env.REACT_APP_API_USERS}/me`) => {
    const config = token ? { headers: {Authorization: 'Bearer ' + token} } : { headers: {Authorization: ''} }
    return axios.get(url, config);
}

export const putUserRole = async(params, url=process.env.REACT_APP_API_USERS) => {
    const body = {
        roles: params.roles
    }
    const config = params.token ? { headers: {Authorization: 'Bearer ' + params.token} } : { headers: {Authorization: ''} }
    return axios.put(`${url}/${params.id}/roles`, body, config);
}

export const postUserProjectAccess = async(params, url=process.env.REACT_APP_API_ACCESS) => {
    const body = {
        user_id: params.userId,
        project_id: params.projectId
    }
    const config = params.token ? { headers: {Authorization: 'Bearer ' + params.token} } : { headers: {Authorization: ''} }
    return axios.post(url, body, config)
}

export const deleteUserProjectAccess = async(params, url=process.env.REACT_APP_API_ACCESS) => {
    const body = {
        user_id: params.userId,
        project_id: params.projectId
    }
    const config = params.token ? { headers: {Authorization: 'Bearer ' + params.token} } : { headers: {Authorization: ''} }
    return axios.delete(url, {...config, data: body})
}

export const deleteUserById = (token, id, url=process.env.REACT_APP_API_USERS) => {
    const config = token ? { headers: {Authorization: 'Bearer ' + token} } : { headers: {Authorization: ''} }
    return axios.delete(`${url}/${id}`, config);
}

export const createNewUser = (token, user, url=process.env.REACT_APP_API_USERS) => {
    const config = token ? { headers: {Authorization: 'Bearer ' + token} } : { headers: {Authorization: ''} }
    return axios.post(url, user, config);
}

export const changePassword = (token, params, url=process.env.REACT_APP_API_CHANGE_PASSWORD) => {
    const body = {
        oldPassword: params.oldPassword,
        password: {
            first: params.newPassword,
            second: params.newPasswordRepeat
        }
    }
    const config = token ? { headers: {Authorization: 'Bearer ' + token} } : { headers: {Authorization: ''} }
    return axios.put(url, body, config);
}

export const changeUserPassword = (token, id, params, url=process.env.REACT_APP_API_USERS) => {
    const body = {
        password: {
            first: params.newPassword,
            second: params.newPasswordRepeat
        }
    }
    const config = token ? { headers: {Authorization: 'Bearer ' + token} } : { headers: {Authorization: ''} }
    return axios.put(`${url}/${id}/change-password`, body, config);
}